"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { trackQuoteRequest } from "@/lib/analytics";

export default function StickyEstimateCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 600px
      setVisible(window.scrollY > 600);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (dismissed) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
    >
      <div className="bg-navy-dark/95 backdrop-blur-xl border-t border-gold/20 shadow-2xl">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-4">
          <div className="flex items-center justify-between gap-4">
            {/* Left: Message */}
            <div className="hidden sm:flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center shrink-0">
                <svg className="w-4 h-4 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <p className="text-white font-semibold text-sm">PCB owners earn avg. <span className="text-gold">$4,200–$8,600/mo</span></p>
                <p className="text-white/40 text-xs">See what your property could earn with Premier</p>
              </div>
            </div>

            {/* Mobile: Short message */}
            <p className="sm:hidden text-white/70 text-sm">
              Earn more with your PCB property
            </p>

            {/* Right: CTAs */}
            <div className="flex items-center gap-3 shrink-0">
              <Link
                href="#roi-calculator"
                onClick={() => trackQuoteRequest('full_service', 'sticky_estimate_my_income')}
                className="btn-gold px-5 sm:px-7 py-2.5 rounded-full font-semibold text-sm flex items-center gap-2 group"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 11h.01M12 11h.01M15 11h.01M4 19h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                Estimate My Income
              </Link>
              <button
                onClick={() => setDismissed(true)}
                className="text-white/30 hover:text-white/60 transition-colors p-1"
                aria-label="Dismiss"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
